import apiClient from "../../../utils/interceptor"
import { ApiResponse, SectionData, CreateSectionParams, CreateSectionResponse, UpdateSectionParams } from "./interface";
import { API_URLS } from "../../../constants";

// Helper function to get auth token from localStorage
const getAuthToken = (): string | null => {
    return localStorage.getItem("auth_token");
};

// Function to get sections by company ID
export const getSectionsByCompanyID = async (companyId: string): Promise<ApiResponse<SectionData[]>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.get<ApiResponse<SectionData[]>>(
            `${API_URLS.SECTION.GET_SECTIONS}?company_id=${companyId}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching sections:", error);
        throw error;
    }
};

// Function to create a section
export const createSection = async (
    sectionParams: CreateSectionParams
): Promise<ApiResponse<CreateSectionResponse>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.post<ApiResponse<CreateSectionResponse>>(
            API_URLS.SECTION.CREATE_SECTION,
            sectionParams,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error creating section:", error);
        throw error;
    }
};

// Function to update a section
export const updateSection = async (
    sectionData: UpdateSectionParams
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.patch<ApiResponse<null>>(
            API_URLS.SECTION.UPDATE_SECTION,
            sectionData,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error updating section:", error);
        throw error;
    }
};

// Function to delete a section
export const deleteSection = async (
    sectionId: string
): Promise<ApiResponse<null>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.delete<ApiResponse<null>>(
            `${API_URLS.SECTION.DELETE_SECTION}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                data: { section_id: sectionId },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error deleting section:", error);
        throw error;
    }
};

// Function to get section types
export const getSectionTypes = async (): Promise<ApiResponse<string[]>> => {
    const token = getAuthToken();

    try {
        const response = await apiClient.get<ApiResponse<string[]>>(
            API_URLS.SECTION.GET_SECTION_TYPES,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Error fetching section types:", error);
        throw error;
    }
};
